import { useCallback } from 'react'
import { useAdviserAnalytics } from '../analytics/use-adviser-analytics'
import { useLaunchHaven } from '@/features/adviser-chat/hooks/useLaunchHaven'
import {
  HAVEN_LAUNCH_ACTION,
  type HavenEntryPoint,
} from '@/features/adviser-chat/lib/types'

export const useLaunchHavenCubk = (entryPoint: HavenEntryPoint) => {
  const { trackEntryPointClicked } = useAdviserAnalytics()
  const launchHaven = useLaunchHaven()

  return useCallback(() => {
    trackEntryPointClicked({
      launchContext: HAVEN_LAUNCH_ACTION.catchUpBookkeeping,
      entryPoint,
    })
    launchHaven({
      context: {
        type: 'action',
        action: HAVEN_LAUNCH_ACTION.catchUpBookkeeping,
      },
      entryPoint,
    })
  }, [entryPoint, launchHaven, trackEntryPointClicked])
}
